import { FormControlLabel, Switch, Typography } from '@material-ui/core';

/**
 * A home card's filter: a small switch with its name beside it, and a name of
 * its own for a screen reader, which hears the switch without the card around it.
 */
export const FilterSwitch = ({
  label,
  ariaLabel,
  checked,
  onChange,
}: {
  label: string;
  ariaLabel: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => (
  <FormControlLabel
    control={
      <Switch
        size="small"
        color="primary"
        checked={checked}
        onChange={event => onChange(event.target.checked)}
        inputProps={{ 'aria-label': ariaLabel }}
      />
    }
    label={
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
    }
  />
);
